<section class="group-view" [attr.aria-busy]="isLoading()">
  <div class="group-view__toolbar ngkit-flex-container-row ngkit-flex-justify-content-space-between ngkit-gap--xxxxs">
    <div class="ngkit-flex-container-column min-width-0">
      <div class="group-view__subtitle">Group</div>
      <div class="group-view__title text-truncate" [fgaEllipsisTitle]="group?.name">{{ group?.name }}</div>
      @if (scimManaged()) {
        <p class="group-view__scim-notice" data-testid="group-view-scim-notice">
          Group is managed by your Organisation's Identity Provider. Contact your IT Administrator to request changes
        </p>
      }
    </div>

    @if (!scimManaged()) {
      <div class="group-view__actions ngkit-flex-container-row ngkit-flex-align-items-end ngkit-flex-none ngkit-gap--xxxs">
        <p-button
          styleClass="ngkit-button ngkit-button-lg"
          severity="primary"
          variant="outlined"
          label="Manage Members"
          icon="pi ds-ngkit-edit"
          (click)="onManageMembers()">
        </p-button>
        <p-button
          styleClass="ngkit-button ngkit-button-lg"
          severity="primary"
          variant="outlined"
          label="Manage Owners"
          icon="pi ds-ngkit-edit"
          (click)="onManageOwners()">
        </p-button>
      </div>
    }
  </div>

  <div class="group-view__tabs ngkit-flex-container-row" role="tablist">
    <button
      type="button"
      class="group-view__tab active"
      role="tab"
      [class.active]="activeTab() === 'members'"
      [attr.aria-selected]="activeTab() === 'members'"
      (click)="setTab('members')"
    >
      Members
    </button>

    @if (!scimManaged()) {
      <button
        type="button"
        class="group-view__tab"
        role="tab"
        [class.active]="activeTab() === 'owners'"
        [attr.aria-selected]="activeTab() === 'owners'"
        (click)="setTab('owners')"
      >
        Owners
      </button>
    }
  </div>

  @if (activeAllRows().length) {
    <div class="group-view__panel" role="tabpanel">
      <div class="group-view__filter ngkit-flex-container-row ngkit-gap--xxxxs">
        <div class="group-view__search-field">
          <ngkit-search
            class="group-view__search ngkit-width-full"
            [placeholder]="filterPlaceholder()"
            [prepopulatedSearchQuery]="filterText()"
            (searchUpdated)="onFilter($event)"
            (searchCleared)="clearFilter()"
          />
        </div>

        <div class="group-view__type-filter">
          <p-selectButton
            class="ngkit-selecttag"
            [attr.data-testid]="tabView().typeFilterTestId"
            [attr.aria-label]="tabView().typeFilterLabel"
            [options]="tabView().typeFilterOptions"
            [allowEmpty]="false"
            optionLabel="label"
            optionValue="value"
            [ngModel]="typeFilterValue()"
            (ngModelChange)="onTypeFilterChange($event)"
          />
        </div>
      </div>

      @if (activeRows().length) {
        <div class="group-view__content">
          <fga-table
            [viewMode]="activeTab()"
            [rows]="activeRows()"
            [hideRemove]="scimManaged()"
            (remove)="onRemove($event)">
          </fga-table>
        </div>
      } @else {
        <div class="group-view__no-results" role="status">
          <p>No {{ activeTab() }} match your filter.</p>
        </div>
      }
    </div>
  } @else {
    <div class="group-view__empty">
      <i class="group-view__empty-icon pi ds-ngkit-users"></i>
      <p class="group-view__empty-message">No {{ activeTab() }} to display</p>
      @if (!scimManaged()) {
        <p class="group-view__empty-action">Add {{ activeTab() === 'members' ? 'a member' : 'an owner' }}</p>
      }
    </div>
  }

  @if (pickerOpen && pickerConfig) {
    <fga-picker-panel
      [config]="pickerConfig"
      (closePanel)="closePicker()"
      (saveChange)="onPickerSave($event)"
    ></fga-picker-panel>
  }
</section>